import { useTranslation } from 'react-i18next'
import { usePromo } from '../context/PromoContext'
import './Sidebar.css'

function Sidebar({ basicPct = 25 }) {
  const { t } = useTranslation()
  const { partnerLogo, partnerWebsite } = usePromo()

  const partnerUrl = partnerWebsite?.startsWith('http') ? partnerWebsite : `https://${partnerWebsite}`

  return (
    <aside className="claimform-sidebar">
      <div className="logo">
        <a href="https://passengersfriend.com/" target="_blank" rel="noopener noreferrer">
          <img src="/images/logos/pf_logo.svg" alt="Passengers friend" width="800" height="264" />
        </a>
      </div>
      {partnerLogo && (
        <div className="partner-logo">
          {partnerWebsite ? (
            <a href={partnerUrl} target="_blank" rel="noopener noreferrer">
              <img src={partnerLogo} alt="Partner" />
            </a>
          ) : (
            <img src={partnerLogo} alt="Partner" />
          )}
        </div>
      )}

      <div className="trust-label" style={{ marginTop: 28 }}>
        {t('sidebar.advantages')}
      </div>

      <div className="trust-item">
        <div className="trust-icon">🏛️</div>
        <div className="trust-txt">
          <strong>{t('sidebar.experts')}</strong>{t('sidebar.expertsSub')}
        </div>
      </div>
      <div className="trust-item">
        <div className="trust-icon">💸</div>
        <div className="trust-txt">
          <strong>{t('sidebar.noWin')}</strong>{t('sidebar.noWinSub')}
        </div>
      </div>
      <div className="trust-item">
        <div className="trust-icon">🤝</div>
        <div className="trust-txt">
          <strong>{t('sidebar.commissionDynamic', { pct: basicPct })}</strong>{t('sidebar.commissionSub')}
        </div>
      </div>
      <div className="trust-item">
        <div className="trust-icon">📞</div>
        <div className="trust-txt">
          <strong>{t('sidebar.personal')}</strong>{t('sidebar.personalSub')}
        </div>
      </div>
      <div className="trust-item">
        <div className="trust-icon">➕</div>
        <div className="trust-txt">
          <strong>{t('sidebar.followUp')}</strong>{t('sidebar.followUpSub')}
        </div>
      </div>

      <div className="g-badge">
        <div className="g-badge-placeholder" aria-hidden="true">
          <span className="g-mark">G</span>
          <span>
            <span className="g-badge-stars"><span className="g-score">4.4</span><span className="g-stars">★★★★<span className="g-star-empty">★</span></span></span>
            <span className="g-count">215 Google reviews</span>
          </span>
        </div>
        <div className="elfsight-app-a1fa35fa-86a8-40f7-89f0-22ba8189e52a" data-elfsight-app-lazy></div>
      </div>

      <div className="divider" style={{ marginTop: 28 }}></div>

      <div className="trust-label" style={{ marginBottom: 12 }}>
        {t('sidebar.media')}
      </div>
      <div className="media-list">
        <div className="media-item">DIE ZEIT</div>
        <div className="media-item">n-tv</div>
        <div className="media-item">Süddeutsche Zeitung</div>
      </div>

      <div className="divider" style={{ marginTop: 28 }}></div>

      <div className="trust-label" style={{ marginBottom: 12 }}>
        {t('sidebar.questions')}
      </div>
      <a href="tel:+4925912539898" className="phone-row">
        <div className="trust-icon">📞</div>
        <div>
          <div className="phone-num">+49 02591 253 98 98</div>
          <div className="phone-hours" style={{ whiteSpace: 'pre-line' }}>
            {t('sidebar.phoneHours')}
          </div>
        </div>
      </a>
    </aside>
  )
}

export default Sidebar
